import { useState, useEffect, useMemo } from 'react';

function useParentWidthResizer(containerRef) {
  const [width, setWidth] = useState(Math.floor(window.innerWidth * 0.8));
  const height = useMemo(() => Math.floor(window.innerHeight * 0.75), []);

  useEffect(() => {
    if (containerRef.current !== null) {
      const getParentWidth = () => {
        const parentElement = containerRef.current.parentElement;
        const { width } = parentElement.getBoundingClientRect();
        setWidth(Math.floor(width * 0.99));
      };

      window.addEventListener('resize', getParentWidth);

      getParentWidth();

      return () => {
        window.removeEventListener('resize', getParentWidth);
      };
    }
  }, [containerRef]);

  return [width, height];
}

export default useParentWidthResizer;
